module.exports = __webpack_public_path__ + "img/JMMP_Website_Projects_Typefaces_03_JM-11.c962ab25.svg";